export default "__VITE_ASSET__f49fd2b8__"